import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	ItemImageContainer,
} from './shopBagItemStyles';

const ItemImage = ({ href, image }) => {
	return (
		<ItemImageContainer>
			<a href={href}>
				<img src={image} width={99} height={66} style={{ maxWidth: "inherit" }} />
			</a>
		</ItemImageContainer>
	);
};

ItemImage.propTypes = {
	href: PropTypes.string.isRequired,
	image: PropTypes.string.isRequired,
};

export default ItemImage;
